import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ArticuloTransferencia } from "@/shared/types/articulo-transferencia";

export async function getArticuloTransferencia(id: string): Promise<ArticuloTransferencia> {
    await sleep(1000);
    const response = await api.get("articulo_transferencias/" + id);
    return response.data;
}

export function useGetArticuloTransferenciaQuery(id: string, queryConfig: QueryConfig<ArticuloTransferencia> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getArticuloTransferencia(id),
        queryKey: ["articulo_transferencias", id],
    })
}

export interface GetArticuloTransferenciaQueryProps {
    id: string,
    queryConfig?: QueryConfig<ArticuloTransferencia>,
    children?: (queryResult: QueryResult<ArticuloTransferencia>) => ReactNode
}

export function GetArticuloTransferenciaQuery({
    id,
    children,
    queryConfig
}: GetArticuloTransferenciaQueryProps) {
    const queryResult = useGetArticuloTransferenciaQuery(id, queryConfig);
    return children && children(queryResult);
}